import React, { useReducer, useState } from 'react';
import logo from '../images/logo.png';
import {
    MDBBtn,
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBSwitch
}
    from 'mdb-react-ui-kit';
import Footer from '../Login/Footer';
import { baseURL } from '../../api/baseURL';
import axios from 'axios';
import Modal from '../../Modal';
import Loader from '../../Loader';
import { useSelector } from 'react-redux';

const AccountRemoval = (history: any, location: any) => {
    const [centredModal, setCentredModal] = useState(false);
    const [userType, setUserType] = useState(window.location.search.split("?")?.[1]);
    const [email, setEmail] = useState("");
    const [requested, setRequested] = useState(false);
    const [err, setErr]: any = useState(false);
    const [success, setSuccess] = useState(false);
    const token = useSelector((state: any) => state.auth.token);


    const toggleOpen = () => setCentredModal(!centredModal);

    const deleteAccount = () => {
        if (email && (userType === "photographer" || userType === "customer") && !requested) {
            setCentredModal(false);
            setRequested(true);
            setErr(false);
            axios.post(`${baseURL}/remove-account`,
                {
                    email,
                    user_type: userType
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.success) {
                        setErr(false);
                        setRequested(false);
                        setSuccess(true);
                        setEmail("");
                    }
                    else {
                        setErr(true);
                        setRequested(false);
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    if (error?.response?.data === "Invalid Email") {
                        setErr("email");
                    }
                    else {
                        setErr(true);
                    }
                    setRequested(false);
                })
        }
    }

    const toggleModal = () => {
        if (err) {
            setErr(false);
        }

        if (success) {
            setSuccess(false);
        }
    }

    const onChangeAccountType = (value: string) => {
        setUserType(value);
      //console.log(userType)
    }

    return (
        <>
            <Modal open={err || success} hideSec primaryText="Okay" title='Update' onConfirm={toggleModal} toggleOpen={toggleModal} content={<h6>{success ? "Your account is removed successfully" : err === "email" ? "Entered email is not registered with us" : "Something went wrong, please try again later"}</h6>} />
            {requested ? <Loader bgLightGray /> : null}
            <MDBContainer className="my-5">
                <MDBCard style={{ backgroundColor: '#FFF', border: 'none' }}>
                    <MDBRow className='g-0'>
                        <MDBCol style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: document.documentElement.clientWidth < 1100 ? '100%' : '75vh' }} md='6'>
                            <MDBCardImage src={logo} style={{ width: document.documentElement.clientWidth < 1100 ? '200px' : '300px' }} alt="login form" className='rounded-start' />
                        </MDBCol>
                        <MDBCol md='6'>
                            <MDBCardBody className='d-flex flex-column'>
                                <div className='d-flex flex-row mt-2'>
                                    <span className="h1 fw-bold mb-0" style={{ color: 'black' }}>Delete Account</span>
                                </div>
                                <p className="fw-normal my-4 pb-3" style={{ letterSpacing: '1px', color: 'black' }}>
                                    We're sorry to see you go! Deleting your account is permanent and cannot be undone. All your account data, will be permanently removed. Some data may be retained as required by law or for security purposes.
                                </p>
                                <p style={{ color: 'black' }}>
                                    If you're sure, please confirm your decision by entering your email address to receive the account removal link.
                                </p>
                                <p style={{ color: 'black' }}>Need help or have questions? Contact us at <a href="mailto:contact@snapwiz.in" target='blank'>contact@snapwiz.in</a></p>
                                <MDBInput onChange={(e) => { setEmail(e?.target?.value); }} wrapperClass='mb-2' className='customFormInput' label='Email address' id='formControlLg' type='email' size="lg" style={{ color: "#171717" }} />
                                <div className="mb-4" style={{ display: 'flex', gap: 30 }}>
                                    <MDBSwitch onChange={(e) => { console.log(e.target.checked); onChangeAccountType(e.target.checked === true ? "customer" : "photographer"); }} checked={userType === "customer" ? true : false} id='switch__' label='Snapwiz Account' wrapperStyle={{ marginLeft: 25 }} />
                                    <MDBSwitch onChange={(e) => { console.log(e.target.checked); onChangeAccountType(e.target.checked !== true ? "customer" : "photographer"); }} checked={userType !== "customer" ? true : false} id='switch__1' label='Snapmaster Account' wrapperStyle={{ marginLeft: 25 }} />
                                </div>
                                <MDBBtn onClick={toggleOpen} className="mb-4 px-5" color='dark' size='lg'>Confirm</MDBBtn>
                            </MDBCardBody>
                        </MDBCol>
                    </MDBRow>
                </MDBCard>
            </MDBContainer >
            <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Delete Account ?</MDBModalTitle>
                            <MDBBtn floating onClick={() => { toggleOpen() }} style={{ display: 'flex', padding: 5, height: 30, width: 30 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
                                    <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" stroke="#FFF" fill="#FFF"></path>
                                </svg>
                            </MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            Are you sure? This action cannot be undone.
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={toggleOpen}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn onClick={() => { deleteAccount() }}>Confirm</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            <Footer />
        </>

    )
}

export default AccountRemoval;
